import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import type { CoachingVisit } from 'src/modules/videoSessions/rematchModels/videoSessions';
import walletIcon from 'src/public/img/wallet-in-circle.svg';
import { StaticItemList } from './StaticItemList';

type Props = {
    sessionDate: string;
    sessionCost: string;
    onCostClick: () => void;
    isPamm?: boolean;
    sessionInfo?: CoachingVisit;
};

export const SessionReviewItemsList: React.FC<Props> = ({
    sessionDate,
    sessionCost,
    onCostClick,
    isPamm,
    sessionInfo,
}) => {
    const { t } = useTranslation();

    return (
        <StaticItemList
            items={[
                {
                    iconName: 'calendar',
                    title: sessionDate,
                    isMarginTopVisible: false,
                },
                {
                    iconUrl: walletIcon,
                    title: isPamm ? (
                        <Trans
                            t={t}
                            ns="videoSessions"
                            i18nKey="session_review.cost_share"
                            values={{
                                cost: sessionCost,
                                sessionType: sessionInfo?.isPsychiatryInitialEvaluation
                                    ? t('videoSessions:session_review.initial_evaluation')
                                    : t('videoSessions:session_review.follow_up'),
                            }}
                            components={{
                                right: <span />,
                            }}
                        />
                    ) : (
                        <Trans
                            t={t}
                            ns="payments"
                            i18nKey="session_review.review_items.cost_v2"
                            values={{
                                cost: sessionCost,
                            }}
                            components={{
                                right: <span />,
                            }}
                        />
                    ),
                    ...(!isPamm && {
                        description: t('payments:session_review.review_items.cost_description'),
                    }),
                    onDescriptionLinkClick: onCostClick,
                    descriptionLinkCta: t(
                        'payments:session_review.review_items.cost_description_cta',
                    ),
                },
            ]}
        />
    );
};
